/* eslint-disable max-len */
import {SERVICE_NAMES} from '../constants';
import {createApiCall} from '../utils';
import type {ServiceName} from '../constants';
import type {
    ApiCallOptions,
    ApiResponseWrapperDocumentView,
    ConfirmDocumentQueryParams,
    PrepareSigningResponse
} from './api.d';

const createSigningApiCall = <T = any>(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
    endpoint: string
) => createApiCall<T>(SERVICE_NAMES.SIGNING as ServiceName, method, endpoint);

export const signingApi = {
    prepareForSigning: ({
        transactionId,
        documentId,
        recipientId,
        certificate,
        options
    }: {
        transactionId: string;
        documentId: string;
        recipientId: string;
        certificate: string;
        options?: ApiCallOptions;
    }) => createSigningApiCall<PrepareSigningResponse>(
        'PUT',
        `transactions/${transactionId}/documents/${documentId}/recipients/${recipientId}/prepare`
    )({...options, data: {certificate}}),

    confirmDocument: ({
        transactionId,
        documentId,
        recipientId,
        data,
        options
    }: {
        transactionId: string;
        documentId: string;
        recipientId: string;
        data?: ConfirmDocumentQueryParams;
        options?: ApiCallOptions;
    }) => createSigningApiCall<ApiResponseWrapperDocumentView>(
        'PUT',
        `transactions/${transactionId}/documents/${documentId}/recipients/${recipientId}/confirm`
    )({...options, data}),

    getEvidenceSummary: ({transactionId, options}: {
        transactionId: string;
        options?: ApiCallOptions;
    }) => createSigningApiCall<Blob>('GET', `transactions/${transactionId}/evidence`)({
        ...options,
        responseType: 'blob',
        headers: {...options?.headers, Accept: 'application/pdf'}
    })
};
